import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { pageEventQuery } from './queries';

export const usePageEventByQuery = () => {
  const { query } = useRouter();
  const { locale } = useLocale();

  const reactQuery = useQuery({
    ...pageEventQuery({ locale, filter: { slug: { eq: `${query.slug}` } } }),
    staleTime: StaleTime.FOREVER,
  });

  return {
    event: reactQuery.data?.pageEvent,
    isLoading: reactQuery.isLoading,
  };
};
